import { useTranslation } from 'react-i18next';
import DeviceComponent from '../components/device/Device';

export default function DeviceList() {
const { t } = useTranslation();
  return (
    <div id={'contents'}>
      <div className={'title'}>
        <p>{t('device.deviceManagement')}</p>
      </div>
      <DeviceComponent />
    </div>
  );
}
